import { render, staticRenderFns } from "./Sellable_Services.vue?vue&type=template&id=2da7e148"
import script from "./Sellable_Services.vue?vue&type=script&lang=ts"
export * from "./Sellable_Services.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports